if (!window.Maximize.loadedScript.includes('pagination.js')) {
  window.Maximize.loadedScript.push('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.data("xPagination", (sectionId) => ({
        loading: false,
        _autoLoadStreak: 0,
        _lastAutoLoadAt: 0,
        loadData(url, isAutomatic) {
          if (isAutomatic) {
            const now = Date.now();
            this._autoLoadStreak = (now - this._lastAutoLoadAt < 3000) ? this._autoLoadStreak + 1 : 1;
            this._lastAutoLoadAt = now;
            if (this._autoLoadStreak > 5) {
              document.dispatchEvent(new CustomEvent('maximize:pagination:auto-load-capped', { detail: { sectionId } }));
              return;
            }
          } else {
            this._autoLoadStreak = 0;
          }

          this.loading = true
          fetch(url)
          .then(response => response.text())
          .then(response => {
            const parser = new DOMParser();
            const html = parser.parseFromString(response,'text/html');
            const productGrid = html.getElementById('ItemsGrid');
            const newProducts = productGrid.getElementsByClassName('grid-item');
            let productsOnPage = document.getElementById("ItemsGrid");
            let blogGrid = document.getElementById("blog-grid");
            if (blogGrid) { productsOnPage = blogGrid }
            for (let i = 0; i < newProducts.length; i++) {
              // setTimeout(() => {
              //   productsOnPage.insertAdjacentHTML('beforeend', newProducts[i].innerHTML);
              // }, i*300);
              productsOnPage.insertAdjacentHTML('beforeend', newProducts[i].innerHTML);
            }
            if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger();
            this._renderButton(html);
          })
          .catch(e => {
            console.error(e);
          })
          .finally(() => {
            this.loading = false;
          })
        } ,
        _renderButton(html) {
          const destination = document.getElementById('btn-pagination-' + sectionId);
          const source = html.getElementById('btn-pagination-' + sectionId);
          if (destination && source) {
            destination.innerHTML = source.innerHTML;
          }
        }
      }));
    });
  });
}
